import { render, staticRenderFns } from "./AccProductReactionList.vue?vue&type=template&id=4d8a271d"
import script from "./AccProductReactionList.vue?vue&type=script&lang=js"
export * from "./AccProductReactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports